export default "__VITE_ASSET__6GRby1nd__"